import React, {useState} from "react";
import {renderCourse} from "../../services/CourseRepository";
import ComplexParser from "../course/ComplexParser";
import {BasicErrorComponent} from "../../components/error/BasicErrorComponent";

export function CourseEditor() {

    const [content, setContent] = useState([]);
    const [text, setText] = useState("");
    const [error, setError] = useState(null);

    const parser = new ComplexParser();

    function updateContent() {
        if (text != null && text !== "") {

            setError(null)
            renderCourse(text).then(async response => {
                console.log(response.data)
                setContent(response.data);
            }).catch((e) => {
                setError(e.response.data)
            })
        }
    }

    return (
        <div className={"p-5 container"}>

            {
                content != null && content.length > 0 ?
                    parser.parseContent(content)
                    :
                    <p>Tomt</p>
            }

            <textarea className={"rounded form-control"} style={{minHeight: "60vh"}} placeholder={"Course content..."}
                      onChange={(e) => setText(e.target.value)}>

                    </textarea>
            <button className={"btn btn-success mt-3"} onClick={() => updateContent()}>Render</button>

            <BasicErrorComponent error={error}/>


        </div>
    )

}